module.exports = "/images/vendor/flag-icon-css/flags/1x1/gb-nir.svg?9cad35c46f775585c615fb8a5b1dc354";